export { DetailsInformationDesk } from './DetailsInformationDesk';
